// 针对不同域名的差异化配置
// 策略：让每个域名主攻一个细分领域或关键词，避免内容完全重复被搜索引擎判定为作弊
const domainConfig = {
  // 默认配置 (兜底)
  'default': {
    title: 'HHpoker官网_德州扑克竞技平台_HH Gaming',
    keywords: 'HHpoker, 德扑圈, 德州扑克, 竞技扑克',
    description: 'HHpoker官方网站，提供专业、公平的德州扑克竞技环境。',
    h1: 'HHpoker 官方平台',
    subtext: '加入全球顶尖的德州扑克竞技社区'
  },
  
  // 1. 主打 "下载" 流量
  'www.anitor.cn': {
    title: 'HHpoker最新版下载_安卓iOS安装包_官方下载渠道',
    keywords: 'HHpoker下载, 德扑圈app安装, 德州扑克手机版, 扑克软件更新',
    description: '提供HHpoker最新版本官方下载，支持iPhone和安卓手机。解决安装失败、更新无法连接等问题，安全无毒，极速下载。',
    h1: 'HHpoker 官方极速下载',
    subtext: '最新的反外挂系统，最流畅的竞技体验'
  },

  // 2. 主打 "俱乐部/圈子" 流量
  'www.booksmalaysia.com': {
    title: 'HHpoker优质俱乐部推荐_高额局_鱼多局_德扑圈子',
    keywords: '德扑圈俱乐部, HHpoker战队, 德州扑克加群, 优质局推荐',
    description: '精选HHpoker（德扑圈）2024年最火爆的俱乐部推荐。包括高额局、娱乐局、大菠萝专场。24小时客服审核，资金安全有保障。',
    h1: 'HHpoker 精选俱乐部',
    subtext: '严选优质圈子，杜绝伙牌，资金保障'
  },

  // 3. 主打 "教学/攻略" 流量
  'www.donghaiedu.com': {
    title: '德州扑克进阶攻略_GTO实战教学_HHpoker技巧分享',
    keywords: '德州扑克教学, GTO策略, 德扑算牌, 扑克起手牌胜率',
    description: '汇集职业牌手实战经验，分享HHpoker平台打法技巧。从新手入门到高阶GTO策略，帮助你提高胜率，长期盈利。',
    h1: '德州扑克大师攻略',
    subtext: '像职业牌手一样思考，掌握核心盈利技巧'
  },

  // 4. 主打 "品牌/综合" 流量
  'www.fishpt.com': {
    title: 'HHpoker官方网站_下载入口与安装指南',
    keywords: 'HHpoker官网, HHpoker官方网站, HHpoker下载入口, HHpoker官方下载, 德扑圈APP下载, HHpoker安装指南',
    description: 'HHpoker官方网站入口，聚合官方下载、安装教程、攻略内容与客服支持，帮助用户快速找到下载与使用所需页面。',
    h1: 'HHpoker 官方网站',
    subtext: '官方下载入口｜iOS安卓安装指引｜战队与攻略一站直达'
  },

  // 5. 主打 "极速/流畅" 流量
  'www.jshstx.com': {
    title: 'HHpoker极速版下载_不卡顿_低延迟德州扑克平台',
    keywords: 'HHpoker加速器, 德扑圈卡顿解决, HHpoker线路优化, 极速德州扑克',
    description: 'HHpoker极速版(jshstx.com)专为网络环境优化，提供多条高速线路，解决卡顿、掉线、延迟高的问题。享受如丝般顺滑的德州扑克竞技体验。',
    h1: 'HHpoker 极速畅玩版',
    subtext: '告别卡顿掉线，毫秒级操作响应'
  },

  // 6. 主打 "代理/加盟" 流量
  'www.xsdstudio.com': {
    title: 'HHpoker合伙人招募_战队代理加盟_高返水工作室合作',
    keywords: 'HHpoker代理, 德扑圈加盟, 德州扑克推广, HHpoker工作室政策',
    description: 'HHpoker官方合作伙伴招募计划(xsdstudio.com)。诚邀各大战队、俱乐部、推广工作室加盟。提供高额返水、专属客服、后台管理系统支持。',
    h1: 'HHpoker 官方合伙人计划',
    subtext: '携手共赢，打造顶级德州扑克生态'
  },

  // 7. 主打 "官网/下载入口" 流量
  'www.ruxinkeji.com': {
    title: 'HHpoker德扑圈官网入口_官方下载_最新下载与客服指南',
    keywords: 'HHpoker德扑圈官网, HHpoker官网入口, HHpoker官方下载, HHpoker最新下载IOS/安卓版/手机版APP, HHpoker怎么联系客服, 德扑圈APP下载',
    description: 'HHpoker官网入口与下载导航(ruxinkeji.com)：覆盖官方下载、最新版本下载、iOS/Android安装指引与客服问题处理，帮助移动端用户快速完成访问到安装全流程。',
    h1: 'HHpoker 官网与下载入口',
    subtext: '官方访问路径 | iOS安卓下载 | 安装问题排查'
  },

  // 8. 主打 "新手/规则" 流量
  'www.zjfhzs.cn': {
    title: 'HHpoker新手学院_德州扑克规则图解_入门基础教程',
    keywords: '德州扑克规则, 德扑新手入门, 牌型大小, HHpoker玩法介绍',
    description: 'HHpoker新手学院(zjfhzs.cn)专为萌新打造。从零开始教你玩德州扑克，图文并茂的规则解析，手把手的入门教程，助你快速上手。',
    h1: 'HHpoker 新手成长学院',
    subtext: '从零开始，开启你的扑克之旅'
  },

  // 9. 主打 "技术解析/稳定" 流量
  'www.cloud-vertex.com': {
    title: 'HHpoker稳定访问入口_下载安装与连接优化指南',
    keywords: 'HHpoker稳定入口, 德扑圈下载, HHpoker安装指南, HHpoker连接优化',
    description: '聚合 HHpoker 稳定访问入口、下载安装步骤与连接优化建议，帮助移动端用户快速完成安装并提升访问稳定性。',
    h1: 'HHpoker 稳定访问与下载入口',
    subtext: '稳定访问 | 下载安装 | 常见连接问题排查'
  },

  // 10. 主打 "客服支持/问题处理" 流量
  'www.glhtc.com': {
    title: 'HHpoker客服支持中心_下载安装问题快速处理',
    keywords: 'HHpoker客服, HHpoker下载问题, HHpoker安装问题, 德扑圈客服支持',
    description: '提供 HHpoker 客服支持入口与问题处理流程，覆盖下载失败、安装异常、版本更新等高频场景。',
    h1: 'HHpoker 客服支持中心',
    subtext: '问题提交更清晰，下载安装处理更高效'
  },

  // 11. 主打 "赛事资讯/社区" 流量
  'www.ynsyptw.com': {
    title: 'HHpoker赛事资讯与社区入口_攻略下载一站式导航',
    keywords: 'HHpoker赛事资讯, 德州扑克攻略, HHpoker下载入口, 德扑圈社区',
    description: '聚合 HHpoker 赛事资讯、攻略内容与下载入口，帮助用户快速获取社区动态并完成安装与使用。',
    h1: 'HHpoker 赛事与社区导航',
    subtext: '赛事动态 | 攻略更新 | 下载入口一站直达'
  },

  // 12. 主打 "下载安装" 流量
  'www.lgysjpj.com': {
    title: 'HHpoker官方下载与安装指南_iOS安卓最新版入口',
    keywords: 'HHpoker官方下载, HHpoker最新下载, HHpoker iOS下载, HHpoker安卓版下载',
    description: '提供 HHpoker 官方下载入口与安装步骤，覆盖 iOS 与 Android 双端，帮助用户快速完成安装和版本更新。',
    h1: 'HHpoker 官方下载与安装指南',
    subtext: '最新版下载 | iOS安卓安装 | 常见问题排查'
  },
  
  // 'www.cloud-vertex.com': { ... },
  // 'www.glhtc.com': { ... },
  // 'www.ynsyptw.com': { ... },
};

// 线上七个域名采用角色化配置，避免同质化互相抢词。
const liveDomainProfiles = {
  'www.ruxinkeji.com': {
    title: 'HHpoker官网入口_官方访问地址_下载与客服导航',
    keywords: 'hhpoker官网, hhpoker官网入口, hhpoker官网地址, hhpoker下载, hhpoker客服',
    description: '主打官网入口与官方访问地址，聚合下载、安装、客服与俱乐部导航，承接品牌与入口词流量。',
    h1: 'HHpoker 官网入口主站',
    subtext: '品牌入口 | 官方地址 | 下载与客服总导航'
  },
  'www.lgysjpj.com': {
    title: 'HHpoker下载_德扑下载官网_最新版安装入口',
    keywords: 'hhpoker下载, hhpoker最新下载, 德扑下载官网, 德扑下载最新版, 德州扑克下载',
    description: '主打下载与安装意图，覆盖最新版包体获取、系统兼容与德扑平台安装教程。',
    h1: 'HHpoker 下载与安装站',
    subtext: '下载入口 | 版本更新 | 安装排障'
  },
  'www.fishpt.com': {
    title: '德州扑克新手教程_规则入门_平台选择指南',
    keywords: '德州扑克新手教程, 德州扑克规则, 德州扑克入门教程, 德州扑克平台怎么选',
    description: '主打教程类搜索意图，覆盖规则、入门路径、平台选择与新手常见问题。',
    h1: '德州扑克教程与规则站',
    subtext: '新手教程 | 规则图解 | 入门路径'
  },
  'swppt.com': {
    title: 'HHpoker客服_联系客服流程_平台问题处理指南',
    keywords: 'hhpoker客服, hhpoker怎么联系客服, 德州扑克平台客服, hhpoker俱乐部客服电话',
    description: '主打客服与问题处理场景，提供下载、安装、账号与俱乐部问题的提交流程。',
    h1: 'HHpoker 客服支持站',
    subtext: '客服入口 | 问题工单 | 处理时效'
  },
  'uannn.com': {
    title: 'HHpoker俱乐部ID_邀请码获取_加入方法大全',
    keywords: 'hhpoker俱乐部id怎么找, hhpoker俱乐部id推荐, 俱乐部邀请码怎么获取, 俱乐部id加入方法',
    description: '主打俱乐部意图词，覆盖俱乐部ID筛选、邀请码获取、加入流程与注意事项。',
    h1: 'HHpoker 俱乐部落地站',
    subtext: 'ID筛选 | 邀请码 | 加入流程'
  },
  'ggxhu.com': {
    title: 'HHpoker官网与下载入口导航_多场景快速直达',
    keywords: 'hhpoker官网入口, hhpoker下载, 德州扑克下载, hhpoker客服',
    description: '作为入口聚合站，承接次级品牌词与导航词，串联下载、教程、俱乐部与客服页。',
    h1: 'HHpoker 导航聚合站',
    subtext: '入口聚合 | 场景直达 | 快速分流'
  },
  'ulkkk.com': {
    title: '德扑下载与入门索引站_新手到进阶一站汇总',
    keywords: '德扑平台下载, 德州扑克下载, 德州扑克新手教程, hhpoker安装教程',
    description: '承接长尾下载与新手词，提供下载入口、安装流程与基础教程索引。',
    h1: '德扑下载与入门索引站',
    subtext: '长尾下载 | 新手教程 | 快速索引'
  }
};

for (const [fullDomain, profile] of Object.entries(liveDomainProfiles)) {
  const bare = fullDomain.replace(/^www\./, '');
  domainConfig[fullDomain] = { ...profile };
  domainConfig[bare] = { ...profile };
}

const incubationDomainAliases = {
  'anitor.cn': 'www.anitor.cn',
  'booksmalaysia.com': 'www.booksmalaysia.com',
  'donghaiedu.com': 'www.donghaiedu.com',
  'jshstx.com': 'www.jshstx.com',
  'xsdstudio.com': 'www.xsdstudio.com',
  'zjfhzs.cn': 'www.zjfhzs.cn'
};

for (const [bareDomain, fullDomain] of Object.entries(incubationDomainAliases)) {
  if (domainConfig[fullDomain]) {
    domainConfig[bareDomain] = { ...domainConfig[fullDomain] };
  }
}

export default domainConfig;
